module.exports = __webpack_public_path__ + "img/5.258f8c71.png";